import {
  Container,
  Button,
  TextField,
  Typography,
  FormControl,
  InputAdornment,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { api } from "../../api/index.js";
import { styles } from "./styles/login.jsx";
import { useTheme } from "@mui/material/styles";
import { handlePostLogin } from "../../utils/authUtils.js";
import { routeSignInStep } from "../../utils/securityService";
import { NoShowIcon, ShowIcon } from "../../feature/core/customIcons.js";
/**
 * This is the card component that is generated for the user to login
 * @returns This returns a generated card the user requires to login
 */
const LoginCard = () => {
  const [warnings, setWarnings] = useState(() => {
    // Nov 2026: explain an automatic idle sign-out once.
    const reason = sessionStorage.getItem("signedOutReason");
    if (reason) sessionStorage.removeItem("signedOutReason");
    return reason || null;
  });
  const [loading, setLoading] = useState(false);
  const [visibilty, setVisibility] = useState(false);

  const navigate = useNavigate();

  const theme = useTheme();
  const style = styles(theme);

  /**
   *This method handles the login flow for the user
   */
  const handleLogin = async () => {
    setLoading(true);
    const email = document.getElementById("email").value;
    const password = document.getElementById("password").value;
    setWarnings("");
    const requestData = { email, password };
    const response = await api("auth", requestData, "login", navigate);
    if (
      (response.status === 200 || response.status === 201) &&
      response.data.accessToken
    ) {
      await handlePostLogin(response, navigate);
    } else if (response.data?.challengeName) {
      // Nov 2026: two-step sign-in code or first-time setup.
      if (routeSignInStep(response.data, navigate)) {
        setLoading(false);
        return;
      }
      if (response.data.challengeName === "NEW_PASSWORD_REQUIRED") {
        navigate("/auth/changePassword", {
          state: {
            email: response.data.email,
            page: "newPassword",
            session: response.data.session,
          },
        });
      }
    } else {
      setWarnings(response.data.message);
    }
    setLoading(false);
  };

  const handleForgotPassword = () => {
    navigate("/auth/forgotPassword");
  };

  const handlePasswordToggle = (id) => {
    const password = document.getElementById(id);
    if (!visibilty) {
      password.type = "text";
      setVisibility(true);
    } else {
      password.type = "password";
      setVisibility(false);
    }
  };

  return (
    <Container sx={style.loginFormWrapper}>
      <Typography sx={style.loginTitle}>Welcome</Typography>
      <Typography sx={style.loginSubTitle}>
        Please sign in to access your account
      </Typography>
      <FormControl sx={style.loginForm}>
        <Typography sx={style.loginInputLabel}>Email Address</Typography>
        <TextField
          sx={style.loginInputTextbox}
          type="text"
          id="email"
          variant="outlined"
          placeholder="Email"
        />
        <Typography sx={style.loginInputLabel}>Password</Typography>
        <TextField
          sx={style.loginInputTextbox}
          type="password"
          id="password"
          variant="outlined"
          placeholder="Password"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {visibilty ? (
                  <ShowIcon
                    sx={style.visibilityIcon}
                    onClick={() => handlePasswordToggle("password")}
                  />
                ) : (
                  <NoShowIcon
                    sx={style.visibilityIcon}
                    onClick={() => handlePasswordToggle("password")}
                  />
                )}
              </InputAdornment>
            ),
          }}
        />
        {warnings && (
          <Typography variant="subtitle1" color="error" sx={style.warningText}>
            {warnings}
          </Typography>
        )}
        <Button
          sx={style.signInButton}
          variant="contained"
          onClick={(event) => handleLogin()}
        >
          {loading ? "Signing In..." : "Sign In"}
        </Button>
      </FormControl>
      <Typography
        sx={style.loginForgotPassword}
        onClick={() => handleForgotPassword()}
      >
        Forgot Your Password?
      </Typography>
    </Container>
  );
};

export default LoginCard;
